import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { shouldShowEquinePremiumAsTbc } from '../equine-premium-tbc.util';
import { getEquineDisplayPremiumData } from '../equine-utils';

@Component({
  selector: 'app-equine-calculations',
  templateUrl: './equine-calculations.component.html',
  styleUrls: ['./equine-calculations.component.css']
})
export class EquineCalculationsComponent implements OnChanges {
  @Input() quoteInfo: any;
  @Input() adjustedPremiumDetails: any = null;
  premiumDetails: any = null;

  get showPremiumAsTbc(): boolean {
    return shouldShowEquinePremiumAsTbc(this.quoteInfo);
  }

    ngOnChanges(changes: SimpleChanges): void {
    if ((changes.quoteInfo && this.quoteInfo) || changes.adjustedPremiumDetails) {
      this.premiumDetails = getEquineDisplayPremiumData(this.quoteInfo, this.adjustedPremiumDetails) ?? [];

      if(this.premiumDetails?.underwriting_fee == null && this.premiumDetails?.uw_fee == null) {
        this.premiumDetails.underwriting_fee = 0.0;
        this.premiumDetails.uw_fee = 0.0;
      }
      if(this.premiumDetails?.ipt_amount === null && this.premiumDetails?.ipt_gross_amount == null) {
        this.premiumDetails.ipt_amount = 0.0;
        this.premiumDetails.ipt_gross_amount = 0.0;
      }
    }
  }
}
